export const INWARD_LINK_DIRECTION = 'INWARD' as const;
export const OUTWARD_LINK_DIRECTION = 'OUTWARD' as const;
export const BOTH_LINK_DIRECTION = 'BOTH' as const;
